function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Chip, styled } from '@mui/material';
var StyledChip = styled(Chip)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var BrandLabel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var text = _ref.text,
    _ref$filled = _ref.filled,
    filled = _ref$filled === void 0 ? true : _ref$filled,
    sx = _ref.sx,
    args = _ref.args;
  return /*#__PURE__*/React.createElement(StyledChip, _extends({
    ref: ref,
    variant: filled ? 'filled' : 'outlined',
    label: text,
    sx: _objectSpread({
      borderRadius: '6px',
      px: '0.5rem',
      fontWeight: 500,
      fontSize: '0.875rem',
      textTransform: 'uppercase',
      userSelect: 'none'
    }, sx)
  }, args));
});
BrandLabel.displayName = 'BrandLabel';
BrandLabel.propTypes = {
  text: PropTypes.string,
  filled: PropTypes.bool,
  args: PropTypes.any
};
BrandLabel.defaultProps = {
  filled: true
};
export default BrandLabel;